import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconChat.module.css';

const IconChat = props => {
  const { rootClassName, className } = props;
  const classes = clsx(rootClassName || css.root, className);
  return (
    <svg 
      className={classes}
      xmlns="http://www.w3.org/2000/svg" 
      width="24" 
      height="24" 
      preserveAspectRatio="xMidYMid meet" 
      id="Layer_1"
      viewBox="0 0 480.9 413">
      <rect x="0" y="0" width="24" height="24" fill="none" stroke="none" />
      <g>
        <path d="M398.3,0H82.5C37,0,0,37,0,82.5V226c0,45.5,37,82.5,82.5,82.5h241.3L335.7,413l71.7-105c41.2-4.5,73.4-39.6,73.4-82V82.5
		C480.9,37,443.9,0,398.3,0z M447.6,226c0,27.2-22.1,49.3-49.3,49.3h-8.8l-30.9,45.2l-5.2-45.2h-271c-27.1,0-49.2-22.1-49.2-49.3
		V82.5c0-27.2,22.1-49.3,49.2-49.3h315.8c27.2,0,49.3,22.1,49.3,49.3V226z"/>
	      <path d="M126.4,122.1c-20.8,0-37.7,16.9-37.7,37.7c0,20.8,16.9,37.7,37.7,37.7c20.8,0,37.7-16.9,37.7-37.7
		C164.1,139,147.2,122.1,126.4,122.1z"/>
	      <path d="M236.4,122.1c-20.8,0-37.7,16.9-37.7,37.7c0,20.8,16.9,37.7,37.7,37.7s37.7-16.9,37.7-37.7
		C274.1,139,257.2,122.1,236.4,122.1z"/>
	      <path d="M346.3,122.1c-20.8,0-37.7,16.9-37.7,37.7c0,20.8,16.9,37.7,37.7,37.7c20.8,0,37.7-16.9,37.7-37.7
		C384,139,367.1,122.1,346.3,122.1z"/>
      </g>
    </svg>
  );
};

IconChat.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

IconChat.propTypes = {
  rootClassName: string,
  className: string,
};

export default IconChat;
